import React from 'react'
import './Advantage_Card.css'

const Advantage_Card = (props) => {
    return (
        <section className='Advantage_Card'>
            <p className='number_text'>
                {props?.number}
            </p>
            <p className='card_title'>
                {props?.title}
            </p>

            <p className='descn'>
            {props?.descn}
            </p>
        </section>
    )
}

export default Advantage_Card
 